import React from 'react';

export function useCallbackRef<T>(callback: (...args: T[]) => void = () => {}) {
  const callbackRef = React.useRef(callback);

  React.useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return React.useCallback((...args) => {
    callbackRef.current(...args);
  }, []);
}
